<app-header></app-header>
<div class="body-container">
    <div class="row">
        <div routerLink="/multirisk" class="home-button" id="multi-risk-link">
            <i class="fab fa-gripfire"></i>
            <div>Multi Risk</div>
        </div>
        <div routerLink="/application" class="home-button" id="new-app-link">
            <i class="fa fa-file-alt"></i>
            <div>New Application</div>
        </div>
        <div class="home-button" id="impersonate-vendor-link" (click)="onImpersonateButtonClick();">
            <i class="fa fa-mask"></i>
            <div>Impersonate Vendor</div>
        </div>
        <div routerLink="/applications" class="home-button" id="app-list-link">
            <i class="fa fa-chart-line"></i>
            <div>Applications List</div>
        </div>
        <div class="home-button" id="ach-converter-link" (click)="onAchDialogButtonClick();">
            <i class="fa fa-stream"></i>
            <div>Ach Documents Converter</div>
        </div>
    </div>
</div>
<app-ach-converter-component></app-ach-converter-component>
<app-footer></app-footer>